import { render, staticRenderFns } from "./recompensasLogros.vue?vue&type=template&id=4ab1b9de&scoped=true"
import script from "./recompensasLogros.vue?vue&type=script&lang=js"
export * from "./recompensasLogros.vue?vue&type=script&lang=js"
import style0 from "./recompensasLogros.vue?vue&type=style&index=0&id=4ab1b9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1b9de",
  null
  
)

export default component.exports